import { render, staticRenderFns } from "./AfegirBalesPartida.vue?vue&type=template&id=f2d150a0&scoped=true"
import script from "./AfegirBalesPartida.vue?vue&type=script&lang=js"
export * from "./AfegirBalesPartida.vue?vue&type=script&lang=js"
import style0 from "./AfegirBalesPartida.vue?vue&type=style&index=0&id=f2d150a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2d150a0",
  null
  
)

export default component.exports